/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-duplicates */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CustomOption } from "components/customOption";
import { podeCorretorConcluirTarefa } from "utils/podeCorretorConcluirTarefa";
import { isAgendamentoAssinatura } from "utils/tiposTarefa";
import { useListarEmpreendimentosAdmin } from "services/api/Admin_Empreendimentos/empreendimentos";
import MaterialUI from "../../../../material-UI";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import * as SVGIcons from "../../../../assets/iconsSVG";
import {
  useDadosBasicosV2,
  useDadosComplementaresV2,
  useLeadsParaTarefa,
  useListarEmpreendimentos2,
  useMotivosDesquealificacao,
  usePreferenciasV2,
  useTiposTarefas,
} from "../../../../services/api";
import { useTiposResultadosTarefa } from "../../../../services/api/Mobile_Tipos_Resultados_Tarefas/tipos-empreendimentos";
import UploadButton from "../../../UploadButton";
import SelectVisitaRetorno from "../../../SelectVisitaRetorno";
import { useCorretorParceiro } from "../../../../services/api/Identity_Usuario/listar-especialistas-produto";
import { refreshTokenAzure } from "../../../../utils/auth_azure";
import Divider from "../../../Divider";
import { useMotivosAtendimento } from "../../../../services/api/AppWeb_Lead/motivos";
import { useListarObjetivosCompras } from "../../../../services/api/Mobile_ObjetivosCompras/objetivos-compras";
import { useListarProfissoes } from "../../../../services/api/DadosComum/profissoes";
import { useTemperaturasLead } from "../../../../services/api/Mobile_Temperatura_Lead/temperaturas-lead";
import { useCadastrarTarefaConcluida } from "../../../../services/api/AppWeb_Lead/cadastrar-tarefa-concluida";
import { useListarUsuariosCorretores } from "../../../../services/api/Identity_Usuario/listar-usuarios-corretores";

interface LeadProps {
  idLeadCorretor: string | undefined;
  nomeLead: string | undefined;
}

interface Props {
  closeModal: () => void;
  idLeadCorretor: string | any;
  idLead: string | any;
  refetch: () => void;
  refetchDataLead?: () => void;
  dataLead: any;
  lead: LeadProps | null;
  fromCarteira?: boolean;
  fromCalendario?: boolean;
  inserirNoOutlookOverride?: boolean;
}

interface SelectProps {
  id: string | null;
  nome: string | null;
}

interface SelectPropsCustom {
  id: string | null;
  nome: string | null;
  codigo: string | null;
  apresentarFlagAssinatura?: boolean;
}

interface FileUploadProps {
  nome: string | null;
  anexoBase64: string | null;
}

const today = new Date();
today.setHours(0, 0, 0, 0);

const NewTaskV2: React.FC<Props> = (props) => {
  const { fromCalendario, inserirNoOutlookOverride } = props;
  const { codigoCargo2013, codigoRegional365 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const isSul = codigoRegional365 === "2";
  const [lead, setLead] = useState<{
    id: string | null;
    nome: string | null;
    idLead: string | null;
  }>();
  const [tipoTarefa, setTipoTarefa] = useState<SelectPropsCustom | null>(null);
  const [assinatura, setAssinatura] = useState(false);
  const [empreendimento, setEmpreendimento] = useState<SelectProps | null>(
    null
  );
  const [empreendimentoNovaTarefa, setEmpreendimentoNovaTarefa] =
    useState<SelectProps | null>(null);
  const [resultado, setResultado] = useState<SelectPropsCustom | null>(null);
  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [descricaoNovaTarefa, setDescricaoNovaTarefa] = useState("");
  const [data, setData] = useState<any>(isSul ? new Date() : null);
  const [hora, setHora] = useState<any>(isSul ? new Date() : null);
  const [
    dataProgramadaRealizacaoNovaTarefa,
    setDataProgramadaRealizacaoNovaTarefa,
  ] = useState<any>(new Date());
  const [
    horaProgramadaRealizacaoNovaTarefa,
    setHoraProgramadaRealizacaoNovaTarefa,
  ] = useState<any>(new Date());
  const [inserirTarefaNoOutlook, setInserirTarefaNoOutlook] = useState(
    fromCalendario ? inserirNoOutlookOverride ?? false : false
  );
  const [concluirTarefa, setConcluirTarefa] = useState(false);
  const [solicitarPresencaEspecialista, setSolicitarPresencaEspecialista] =
    useState(false);
  const [observacao, setObservacao] = useState("");
  const [fileUpload, setFileUpload] = useState<FileUploadProps | null>(null);
  const [tipoVisitaRetorno, setTipoVisitaRetorno] = useState(1);
  const [localSul, setLocalSul] = useState(null);
  const [produtoSul, setProdutoSul] = useState<SelectProps | null>(null);
  const [corretorParceiro, setCorretorParceiro] = useState<SelectProps | null>(
    null
  );
  const [usuarioCorretor, setUsuarioCorretor] = useState<SelectProps | null>(
    null
  );
  const [temperaturaLead, setTemperaturaLead] = useState<SelectProps | null>(
    null
  );
  const [motivoDesqualificacao, setMotivoDesqualificacao] =
    useState<SelectProps | null>(null);
  const [profissao, setProfissao] = useState<SelectProps | null>(null);
  const [idade, setIdade] = useState<string>("");
  const [bairro, setBairro] = useState<string>("");
  const [temperatura, setTemperatura] = useState<SelectProps | null>(null);
  const [tokenAD, setTokenAD] = useState<string | null>("");
  const [motivoAtendimento, setMotivoAtendimento] =
    useState<SelectProps | null>(null);
  const [objetivoCompra, setObjetivoCompra] = useState<SelectProps | null>(
    null
  );
  const [isFutureDate, setIsFutureDate] = useState(false);

  const { data: dataLeads, refetch: refetchLeads } = useLeadsParaTarefa({
    queryKey: "nova_tarefa_leads",
  });
  const { data: dataTipoTarefas, refetch: refetchTiposTarefas } =
    useTiposTarefas({
      queryKey: "nova_tarefa_tipos_tarefas",
    });
  const { data: dataEmpreendimentoSul, refetch: refetchEmpreendimentosSul } =
    useListarEmpreendimentosAdmin();
  const { data: dataEmpreendimento2, refetch: refetchEmpreedimentos2 } =
    useListarEmpreendimentos2();
  const {
    data: dataTiposResultadosTarefa,
    refetch: refetchTiposResultadosTarefa,
  } = useTiposResultadosTarefa({
    idTipoTarefa: tipoTarefa?.id ? tipoTarefa?.id : "",
    queryKey: "nova_tarefa_resultados_tarefa",
  });
  // const { data: dataEmpreendimentosSul, refetch: refetchEmpreendimentosSul } =
  //   useEmpreendimentosValidosSul({
  //     queryKey: "empreendimentos_sul",
  //   });
  const { data: dataCorretorParceiro, refetch: refetchCorretorParceiro } =
    useCorretorParceiro({
      queryKey: "corretor_parceiro",
    });
  const { data: dataUsuariosCorretores, refetch: refetchUsuariosCorretores } =
    useListarUsuariosCorretores({
      isSul,
      queryKey: "listar_usuarios_corretores",
    });
  const {
    data: dataMotivosDesqualificacao,
    refetch: refetchMotivosDesqualificacao,
  } = useMotivosDesquealificacao({
    queryKey: "motivos_desqualificacao_tarefas",
  });
  const { data: dataMotivosAtendimento, refetch: refetchMotivosAtendimento } =
    useMotivosAtendimento({
      tipoDeAtendimento: tipoVisitaRetorno,
      queryKey: "motivos_tipo_atendimento_tarefas",
    });
  const { data: dataObjetivosCompra, refetch: refetchObjetivosCompras } =
    useListarObjetivosCompras();
  const { data: dataProfissoes, refetch: refetchProfissoes } =
    useListarProfissoes();
  const { data: dataTemperaturasLead, refetch: refetchTemperaturasLead } =
    useTemperaturasLead();
  const { data: dataDadosComplementares, refetch: refetchDadosComplementares } =
    useDadosComplementaresV2({
      idLeadCorretor: lead?.id ? lead?.id : "",
      queryKey: "nova_tarefa_dados_complementares",
    });
  const { data: dataDadosBasicos, refetch: refetchDadosBasicos } =
    useDadosBasicosV2({
      idLeadCorretor: lead?.id ? lead?.id : "",
      queryKey: "nova_tarefa_dados_basicos",
    });
  const {
    data: preferenciasLead,
    refetch: refetchPreferenciasLead,
    isRefetching: isRefetchingPreferenciasLead,
    isFetched,
  } = usePreferenciasV2({
    idLeadCorretor: lead?.id ? lead?.id : "",
    queryKey: "dados-complementares-lead-detail",
  });

  const gerarIdade = (dataAtualStr: string, dataStr: string) => {
    const dataAtual: any = new Date(dataAtualStr);
    const dataNascimento: any = new Date(dataStr);

    const diferencaEmMilissegundos: any = dataAtual - dataNascimento;

    const idadeEmAnos = Math.floor(
      diferencaEmMilissegundos / (1000 * 60 * 60 * 24 * 365.25)
    );
    return idadeEmAnos.toString();
  };

  useEffect(() => {
    if (data) {
      const dataHora = new Date(data);
      if (hora instanceof Date && !isNaN(hora.getTime())) {
        dataHora.setHours(hora.getHours(), hora.getMinutes(), 0, 0);
      } else {
        dataHora.setHours(0, 0, 0, 0);
      }
      if (new Date() < dataHora) {
        setIsFutureDate(true);
      } else setIsFutureDate(false);
    }
  }, [data, hora]);

  useEffect(() => {
    if (isSul && isFutureDate) {
      setConcluirTarefa(false);
    }
  }, [isFutureDate, isSul]);

  useEffect(() => {
    if (dataDadosComplementares) {
      setProfissao({
        id: dataDadosComplementares?.idProfissao,
        nome: dataDadosComplementares?.profissao,
      });
      setObjetivoCompra({
        id: dataDadosComplementares?.idObjetivoCompra,
        nome: dataDadosComplementares?.objetivoCompra,
      });
      setBairro(
        dataDadosComplementares.bairro === null
          ? ""
          : dataDadosComplementares.bairro
      );
      if (dataDadosComplementares?.dataNascimento !== null) {
        const partesDataNascimento =
          dataDadosComplementares?.dataNascimento.split("/");
        const dataNascimentoFormatada = `${partesDataNascimento[2]}-${partesDataNascimento[1]}-${partesDataNascimento[0]}`;
        setIdade(
          gerarIdade(format(new Date(), "yyyy-MM-dd"), dataNascimentoFormatada)
        );
      }
    }
  }, [dataDadosComplementares]);

  useEffect(() => {
    if (preferenciasLead && isSul) {
      setEmpreendimento({
        id: preferenciasLead?.idEmpreendimento,
        nome: preferenciasLead?.nomeEmpreendimento,
      });
    }
  }, [preferenciasLead]);

  useEffect(() => {
    if (dataDadosBasicos?.idTemperaturaLead !== null) {
      setTemperatura({
        id: dataDadosBasicos?.idTemperaturaLead
          ? dataDadosBasicos?.idTemperaturaLead
          : "",
        nome: dataDadosBasicos?.temperaturaLead
          ? dataDadosBasicos?.temperaturaLead
          : "",
      });
    }
  }, [dataDadosBasicos]);

  useEffect(() => {
    setResultado(null);
  }, [tipoVisitaRetorno]);

  useEffect(() => {
    if (props?.lead?.idLeadCorretor) {
      setLead({
        id: props?.lead?.idLeadCorretor ? props?.lead?.idLeadCorretor : null,
        nome: props?.lead?.nomeLead ? props?.lead?.nomeLead : null,
        idLead: null,
      });
    }
  }, []);

  useEffect(() => {
    if (inserirTarefaNoOutlook === true) {
      requestToken();
    }
  }, [inserirTarefaNoOutlook]);

  const requestToken = async () => {
    const toJson = await localStorage.getItem("@token");
    const datas = toJson == null ? null : JSON.parse(toJson);
    if (!datas.tokenAD) {
      const tokenStorage = await refreshTokenAzure();
      setTokenAD(tokenStorage);
    } else {
      setTokenAD(datas.tokenAD);
    }
  };

  useEffect(() => {
    refetchLeads();
    refetchTiposTarefas();
  }, []);

  useEffect(() => {
    if (tipoTarefa?.codigo !== "1" || tipoVisitaRetorno === 1) {
      setSolicitarPresencaEspecialista(false);
    }
  }, [tipoTarefa, tipoVisitaRetorno]);

  useEffect(() => {
    if (
      resultado?.codigo === "2" ||
      resultado?.codigo === "9" ||
      resultado?.codigo === "10"
    ) {
      refetchEmpreedimentos2();
      refetchEmpreendimentosSul();
    } else {
      setEmpreendimentoNovaTarefa(null);
    }
  }, [resultado]);

  useEffect(() => {
    setResultado(null);
    if (
      tipoTarefa?.codigo === "1" ||
      isAgendamentoAssinatura(tipoTarefa?.nome)
    ) {
      refetchEmpreedimentos2();
    }
  }, [tipoTarefa]);

  useEffect(() => {
    if (resultado?.codigo === "5") {
      refetchMotivosDesqualificacao();
    } else {
      setMotivoDesqualificacao(null);
    }
  }, [resultado]);

  useEffect(() => {
    if (resultado?.codigo === "4" && lead !== null) {
      refetchMotivosAtendimento();
      refetchObjetivosCompras();
      refetchProfissoes();
      refetchTemperaturasLead();
      refetchDadosComplementares();
      refetchDadosBasicos();
      refetchPreferenciasLead();
    } else {
      setMotivoAtendimento(null);
    }
  }, [resultado]);

  useEffect(() => {
    if (concluirTarefa === true) {
      refetchTiposResultadosTarefa();
    } else {
      setResultado(null);
    }
  }, [concluirTarefa, tipoTarefa]);

  useEffect(() => {
    if (tipoTarefa?.codigo !== "1") {
      setLocalSul(null);
      setProdutoSul(null);
      setCorretorParceiro(null);
      setTipoVisitaRetorno(1);
    }
    if (isSul && tipoTarefa?.codigo === "1") {
      refetchEmpreendimentosSul();
      refetchCorretorParceiro();
      refetchUsuariosCorretores();
    }
  }, [isSul, tipoTarefa]);

  useEffect(() => {
    if (isAgendamentoAssinatura(tipoTarefa?.nome)) {
      return setTitulo(
        `Assinatura agendada com ${lead?.nome ? lead?.nome : ""}`
      );
    }
    switch (tipoTarefa?.nome) {
      case "Ligação":
        return setTitulo(`Ligar para ${lead?.nome ? lead?.nome : ""}`);
      case "WhatsApp":
        return setTitulo(
          `Enviar mensagem para ${lead?.nome ? lead?.nome : ""}`
        );
      case "Agendamento de Visita":
        return setTitulo(`Visita agendada com ${lead?.nome ? lead?.nome : ""}`);
      case "Atendimento":
        return setTitulo(`Visita agendada com ${lead?.nome ? lead?.nome : ""}`);
      case "E-mail":
        return setTitulo(`Enviar e-mail para ${lead?.nome ? lead?.nome : ""}`);
      default:
        return setTitulo("");
    }
  }, [tipoTarefa, lead]);

  function formatarBase64(string: string) {
    const partes = string?.split(",");
    if (partes?.length === 2) {
      return partes[1];
    }
    return null;
  }

  React.useEffect(() => {
    setEmpreendimento(null);
    // Corretor não conclui Agendamento de Visita/Assinatura em SP/RJ — garante
    // que o estado não fique "true" ao trocar para um tipo sem essa opção.
    if (!podeCorretorConcluirTarefa(tipoTarefa?.nome, isSul)) {
      setConcluirTarefa(false);
    }
    if (!(isSul && tipoTarefa?.apresentarFlagAssinatura)) {
      setAssinatura(false);
    }
  }, [tipoTarefa]);

  const params = {
    idLead365: props?.idLead ? props?.idLead : lead?.idLead,
    idLeadCorretor365: props?.idLeadCorretor ? props?.idLeadCorretor : lead?.id,
    idTipoTarefa365: tipoTarefa?.id,
    idEmpreendimento365: isSul
      ? null
      : empreendimento?.id
      ? empreendimento?.id
      : null,
    idEmpreendimento365NovaTarefa: isSul
      ? produtoSul?.id
      : empreendimentoNovaTarefa?.id || empreendimento?.id,
    titulo,
    descricao,
    // @ts-ignore
    dataProgramadaRealizacaoTarefa: !isNaN(Date.parse(data))
      ? format(data, "yyyy-MM-dd")
      : null,
    // @ts-ignore
    horaProgramadaRealizacaoTarefa: !isNaN(Date.parse(hora))
      ? format(hora, "HH:mm:ss")
      : null,
    dataProgramadaRealizacaoNovaTarefa:
      concluirTarefa &&
      (resultado?.codigo === "2" ||
        resultado?.codigo === "8" ||
        resultado?.codigo === "9" ||
        resultado?.codigo === "10")
        ? !isNaN(Date.parse(dataProgramadaRealizacaoNovaTarefa))
          ? format(dataProgramadaRealizacaoNovaTarefa, "yyyy-MM-dd")
          : null
        : null,
    horaProgramadaRealizacaoNovaTarefa:
      concluirTarefa &&
      (resultado?.codigo === "2" ||
        resultado?.codigo === "8" ||
        resultado?.codigo === "9" ||
        resultado?.codigo === "10")
        ? !isNaN(Date.parse(horaProgramadaRealizacaoNovaTarefa))
          ? format(horaProgramadaRealizacaoNovaTarefa, "HH:mm:ss")
          : null
        : null,
    inserirTarefaNoOutlook,
    tokenAd: tokenAD,
    anexo: !concluirTarefa ? null : fileUpload,
    idTipoResultadoTarefa365: !concluirTarefa ? null : resultado?.id,
    observacoes: !concluirTarefa ? null : observacao,
    idMotivoDesqualificacaoLead365: motivoDesqualificacao?.id,
    codigoTipoAgendamentoVisita: !isSul ? null : tipoVisitaRetorno,
    localRegionalSul: !isSul ? null : localSul,
    idCorretorParceiro365: isSul ? usuarioCorretor?.id : null,
    solicitarPresencaEspecialista,
    idProfissao365: !concluirTarefa ? null : profissao?.id,
    idade: !concluirTarefa ? null : idade,
    bairro: !concluirTarefa ? null : bairro,
    idUsuarioEspecialista: !isSul ? null : corretorParceiro?.id,
    idEmpreendimento365RegionalSul: isSul
      ? tipoTarefa?.codigo === "1"
        ? produtoSul?.id
        : null
      : null,
    idTemperaturaLead365: isSul ? temperatura?.id : null,
    assinatura:
      isSul && tipoTarefa?.apresentarFlagAssinatura ? assinatura : null,
    concluirTarefa,
    descricaoNovaTarefa:
      descricaoNovaTarefa.length > 0 ? descricaoNovaTarefa : null,
    codigoMotivo: motivoAtendimento?.id,
    idObjetivoCompra: objetivoCompra?.id,
  };

  const { mutate, isLoading, isSuccess } = useCadastrarTarefaConcluida({
    body: params,
  });

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
      props?.refetch();
      if (resultado?.codigo === "5") {
        window.location.href = "/transferencia-concluida/desqualificado";
      }
      if (props.refetchDataLead) {
        props.refetchDataLead();
      }
    }
  }, [isSuccess]);

  useEffect(() => {
    if (concluirTarefa) {
      setSolicitarPresencaEspecialista(false);
      setInserirTarefaNoOutlook(false);
    }
  }, [concluirTarefa]);

  // const validateFields = () => {
  //   let validationFail = false;

  //   if (isSul && tipoTarefa?.codigo === "1") {
  //     if (localSul?.length > 0) {
  //       validationFail = false;
  //       if (produtoSul) {
  //         validationFail = false;
  //       } else {
  //         validationFail = true;
  //         toast.error(`O campo "Produto" é obrigatório`, {
  //           autoClose: 10000,
  //         });
  //       }
  //     } else {
  //       validationFail = true;
  //       toast.error(`O campo "Local" é obrigatório`, {
  //         autoClose: 10000,
  //       });
  //     }
  //   }

  //   if (concluirTarefa) {
  //     if (resultado) {
  //       validationFail = false;
  //       if (observacao?.length > 0) {
  //         validationFail = false;
  //       } else {
  //         validationFail = true;
  //         toast.error(`O campo "Observação sobre o resultado" é obrigatório`, {
  //           autoClose: 10000,
  //         });
  //       }
  //     } else {
  //       validationFail = true;
  //       toast.error(`O campo "Resultado" é obrigatório`, {
  //         autoClose: 10000,
  //       });
  //     }
  //   }

  //   return validationFail;
  // };

  const ehAgendamentoAssinatura = isAgendamentoAssinatura(tipoTarefa?.nome);

  // Agendamento de Assinatura exige Produto/Empreendimento em SP/RJ.
  const empreendimentoNaoInformado =
    ehAgendamentoAssinatura && !isSul && !empreendimento?.id;

  // Agendamento de Assinatura exige Data/Hora igual ou posterior à atual.
  const dataAssinaturaNoPassado = (() => {
    if (!ehAgendamentoAssinatura || !data || isNaN(Date.parse(data))) {
      return false;
    }
    const dataHora = new Date(data);
    if (hora instanceof Date && !isNaN(hora.getTime())) {
      dataHora.setHours(hora.getHours(), hora.getMinutes(), 0, 0);
    } else {
      dataHora.setHours(0, 0, 0, 0);
    }
    return dataHora < new Date();
  })();

  const handleSubmit = () => {
    if (empreendimentoNaoInformado) {
      toast.error("Produto/Empreendimento não informado", {
        autoClose: 10000,
      });
      return;
    }

    if (dataAssinaturaNoPassado) {
      toast.error("A data deve ser igual ou posterior à data atual", {
        autoClose: 10000,
      });
      return;
    }

    mutate();
  };
  function generateResultados() {
    if (dataTiposResultadosTarefa) {
      if (isSul) {
        if (tipoTarefa?.codigo === "1" && tipoVisitaRetorno === 1) {
          return dataTiposResultadosTarefa?.data
            ?.map((item: any) => ({
              id: item?.id,
              nome: item?.nome,
              codigo: item?.codigo,
              resultadoAtualizaLead: item?.resultadoAtualizaLead,
            }))
            .filter((item: any) => item.codigo === "4");
        }
        if (tipoTarefa?.codigo === "1" && tipoVisitaRetorno === 2) {
          return dataTiposResultadosTarefa?.data?.map((item: any) => ({
            id: item?.id,
            nome: item?.nome,
            codigo: item?.codigo,
            resultadoAtualizaLead: item?.resultadoAtualizaLead,
          }));
        }
        if (tipoTarefa?.codigo !== "1") {
          return dataTiposResultadosTarefa?.data?.map((item: any) => ({
            id: item?.id,
            nome: item?.nome,
            codigo: item?.codigo,
            resultadoAtualizaLead: item?.resultadoAtualizaLead,
          }));
        }
      }
      return dataTiposResultadosTarefa?.data?.map((item: any) => ({
        id: item?.id,
        nome: item?.nome,
        codigo: item?.codigo,
        resultadoAtualizaLead: item?.resultadoAtualizaLead,
      }));
    }
    return [];
  }

  const canNotClickButtonSave = isSul ? produtoSul === null : false;

  const exibirConcluirTarefa = podeCorretorConcluirTarefa(
    tipoTarefa?.nome,
    isSul
  );

  // Agendamento de Assinatura segue o mesmo padrão de Visita: em SP/RJ exibe o
  // campo Produto (empreendimento). O de Visita usa codigo === "1".
  const exibirProdutoNaoSul =
    !isSul && (tipoTarefa?.codigo === "1" || ehAgendamentoAssinatura);

  const canSaveSul = isSul
    ? (resultado?.codigo === "4"
        ? observacao?.length >= 15 &&
          !!motivoAtendimento &&
          !!corretorParceiro &&
          !!objetivoCompra &&
          !!profissao &&
          !!bairro &&
          !!idade &&
          !!temperatura
        : true) &&
      (tipoVisitaRetorno === 1 && tipoTarefa?.codigo === "1"
        ? !isFutureDate
        : true)
    : true;

  return (
    <Styles.DialogHeader
      style={{
        display: "flex",
        flex: 1,
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Styles.ScrollContentV2>
        {!props?.lead?.idLeadCorretor ? (
          <>
            <Styles.RowGap>
              <Styles.Column>
                <Styles.LabelText>
                  Lead <p>*</p>
                </Styles.LabelText>
                <Styles.Autocomplete
                  id="combo-box-demo"
                  fullWidth
                  options={
                    dataLeads
                      ? dataLeads?.data?.map((item: any) => ({
                          id: item?.idLeadCorretor365,
                          nome: item?.nomeLead,
                          idLead: item?.idLead365,
                        }))
                      : []
                  }
                  value={lead}
                  renderInput={(params: any) => (
                    <>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Resultado *"
                        required
                        fullWidth
                      />
                    </>
                  )}
                  getOptionSelected={(option: any) => option?.nome}
                  getOptionLabel={(option: any) => option?.nome || ""}
                  // @ts-ignore
                  onChange={(
                    event: any,
                    newValue: {
                      id: string | null;
                      nome: string | null;
                      idLead: string | null;
                    }
                  ) => {
                    setLead(newValue);
                  }}
                />
              </Styles.Column>
            </Styles.RowGap>
            <Styles.SpaceY space={16} />
          </>
        ) : null}

        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>
              Tipo da tarefa <p>{" *"}</p>
            </Styles.LabelText>
            <Styles.Autocomplete
              id="combo-box-demo"
              defaultValue={{
                nome: "Selecione um tipo da tarefa",
                id: "1",
              }}
              fullWidth
              options={
                dataTipoTarefas
                  ? dataTipoTarefas?.data?.map((item: any) => ({
                      id: item?.id,
                      nome: item?.nome,
                      codigo: item?.codigo,
                      apresentarFlagAssinatura: item?.apresentarFlagAssinatura,
                    }))
                  : []
              }
              value={tipoTarefa}
              renderInput={(params: any) => (
                <>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Tipo da tarefa"
                    required
                    fullWidth
                  />
                </>
              )}
              getOptionSelected={(option: any) => option?.nome}
              getOptionLabel={(option: any) => option?.nome || ""}
              // @ts-ignore
              onChange={(
                event: any,
                newValue: {
                  id: string | null;
                  nome: string | null;
                  codigo: string | null;
                  apresentarFlagAssinatura?: boolean;
                } | null
              ) => {
                setTipoTarefa(newValue);
              }}
            />
          </Styles.Column>
        </Styles.RowGap>
        {isSul && tipoTarefa?.apresentarFlagAssinatura ? (
          <Styles.RowGap>
            <Styles.FormControlLabel
              control={
                <Styles.Checkbox
                  checked={assinatura}
                  onChange={() => setAssinatura(!assinatura)}
                />
              }
              label="Assinatura"
            />
          </Styles.RowGap>
        ) : null}
        <Styles.SpaceY space={8} />
        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>
              Titulo <p>{" *"}</p>
            </Styles.LabelText>
            <Styles.TextField
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              label="Titulo"
              fullWidth
              onChange={(e: any) => setTitulo(e.target.value)}
              value={titulo}
            />
          </Styles.Column>
        </Styles.RowGap>
        <Styles.RowGap>
          <Styles.Column>
            <Styles.LabelText>
              Data <p>{" *"}</p>
            </Styles.LabelText>
            <Styles.LocalizationProvider
              locale={ptBR}
              dateAdapter={MaterialUI.AdapterDateFns}
            >
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={data}
                components={{
                  OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setData(newValue)}
                minDate={ehAgendamentoAssinatura ? today : undefined}
                maxDate={
                  isSul && tipoVisitaRetorno === 1 && tipoTarefa?.codigo === "1"
                    ? new Date()
                    : null
                }
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Data *"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.LocalizationProvider>
          </Styles.Column>
          <Styles.Column>
            <Styles.LabelText>
              Hora <p>{" *"}</p>
            </Styles.LabelText>
            <Styles.LocalizationProvider
              locale={ptBR}
              dateAdapter={MaterialUI.AdapterDateFns}
            >
              <Styles.TimePicker
                inputFormat="HH:mm"
                value={hora}
                components={{
                  OpenPickerIcon: SVGIcons.ClockIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setHora(newValue)}
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Hora *"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.LocalizationProvider>
          </Styles.Column>
        </Styles.RowGap>
        {exibirProdutoNaoSul ? (
          <Styles.RowGap>
            <Styles.Column>
              <Styles.LabelText>
                Produto <p>{" *"}</p>
              </Styles.LabelText>
              <Styles.Autocomplete
                id="combo-box-demo"
                fullWidth
                options={
                  dataEmpreendimento2
                    ? dataEmpreendimento2?.data?.map((item: any) => ({
                        id: item?.id,
                        nome: item?.nome,
                      }))
                    : []
                }
                value={empreendimento}
                renderInput={(params: any) => (
                  <>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Resultado *"
                      required
                      fullWidth
                    />
                  </>
                )}
                getOptionSelected={(option: any) => option?.nome}
                getOptionLabel={(option: any) => option?.nome || ""}
                // @ts-ignore
                onChange={(
                  event: any,
                  newValue: {
                    id: string | null;
                    nome: string | null;
                  } | null
                ) => {
                  setEmpreendimento(newValue);
                }}
              />
            </Styles.Column>
          </Styles.RowGap>
        ) : null}
        {tipoTarefa?.codigo === "1" && isSul ? (
          <>
            <Styles.SpaceY space={8} />
            <SelectVisitaRetorno
              value={tipoVisitaRetorno}
              onChangeValue={(val: number) => setTipoVisitaRetorno(val)}
            />
            <Styles.SpaceY space={8} />
            <Styles.RowGap>
              <Styles.Column>
                <Styles.LabelText>
                  Local <p>{"*"}</p>
                </Styles.LabelText>
                <Styles.Autocomplete
                  id="combo-box-demo"
                  fullWidth
                  options={
                    dataEmpreendimentoSul
                      ? dataEmpreendimentoSul?.data?.map((item: any) => ({
                          id: item?.idEmpreendimento,
                          nome: item?.nome,
                        }))
                      : []
                  }
                  value={produtoSul}
                  renderInput={(params: any) => (
                    <>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Tipo da tarefa"
                        required
                        fullWidth
                      />
                    </>
                  )}
                  getOptionSelected={(option: any) => option?.nome}
                  getOptionLabel={(option: any) => option?.nome || ""}
                  // @ts-ignore
                  onChange={(event: any, newValue: any) => {
                    setProdutoSul(newValue);
                  }}
                />
              </Styles.Column>
            </Styles.RowGap>
            <Styles.SpaceY space={16} />
            <Styles.RowGap>
              <Styles.Column>
                <Styles.LabelText>Corretor parceiro</Styles.LabelText>
                <Styles.Autocomplete
                  id="combo-box-demo"
                  defaultValue={{
                    nome: "Selecione um tipo da tarefa",
                    id: "1",
                  }}
                  fullWidth
                  options={
                    dataUsuariosCorretores
                      ? dataUsuariosCorretores?.data?.map((item: any) => ({
                          id: item?.idCorretor,
                          nome: item?.nome,
                        }))
                      : []
                  }
                  value={usuarioCorretor}
                  renderInput={(params: any) => (
                    <>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Tipo da tarefa"
                        required
                        fullWidth
                      />
                    </>
                  )}
                  getOptionSelected={(option: any) => option?.nome}
                  getOptionLabel={(option: any) => option?.nome || ""}
                  // @ts-ignore
                  onChange={(event: any, newValue: any) => {
                    setUsuarioCorretor(newValue);
                  }}
                />
              </Styles.Column>
            </Styles.RowGap>
          </>
        ) : null}
        <Styles.RowGap>
          <Styles.MultLineField>
            <Styles.LabelText>Descrição</Styles.LabelText>
            <Styles.TextField
              onChange={(e: any) => setDescricao(e.target.value)}
              label="Multiline"
              variant="outlined"
              fullWidth
              multiline
              minRows={3}
              value={descricao}
              inputProps={{ maxLength: 4000 }}
            />
            <Styles.CountText>{descricao.length}/4000</Styles.CountText>
          </Styles.MultLineField>
        </Styles.RowGap>
        {isSul &&
        tipoTarefa?.codigo === "1" &&
        tipoVisitaRetorno !== 1 &&
        isFutureDate ? (
          <Styles.RowGap>
            <Styles.FormControlLabel
              control={
                <Styles.Checkbox
                  defaultChecked
                  checked={solicitarPresencaEspecialista}
                  onChange={() =>
                    setSolicitarPresencaEspecialista(
                      !solicitarPresencaEspecialista
                    )
                  }
                />
              }
              label="Solicitar presença de um especialista"
            />
          </Styles.RowGap>
        ) : null}
        <div style={{ display: "flex", gap: 8 }}>
          {!(fromCalendario && inserirNoOutlookOverride) &&
            (isSul && tipoVisitaRetorno === 1 ? null : isSul &&
              tipoVisitaRetorno !== 1 &&
              !isFutureDate ? null : (
              <Styles.RowGap>
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={inserirTarefaNoOutlook}
                        disabled={concluirTarefa}
                        onChange={() =>
                          setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                        }
                      />
                    }
                    label="Criar compromisso na agenda"
                  />
                </Styles.RowGap>
              </Styles.RowGap>
            ))}

          {!exibirConcluirTarefa || (isSul && isFutureDate) ? null : (
            <Styles.RowGap>
              <Styles.FormControlLabel
                control={
                  <Styles.Checkbox
                    defaultChecked
                    checked={concluirTarefa}
                    onChange={() => setConcluirTarefa(!concluirTarefa)}
                  />
                }
                label="Concluir tarefa"
              />
            </Styles.RowGap>
          )}
        </div>
        {concluirTarefa ? (
          <>
            <Styles.RowGap>
              <Styles.Column>
                <Styles.LabelText>
                  Resultado <p>{" *"}</p>{" "}
                  <Styles.LabelIcon>
                    <SVGIcons.InfoIcon className="info-icon" />
                    <Styles.FloatText className="float-text">
                      <SVGIcons.CheckWhiteIcon className="check-icon" />
                      Resultados que atualizam o lead
                    </Styles.FloatText>
                  </Styles.LabelIcon>
                </Styles.LabelText>
                <Styles.Autocomplete
                  id="combo-box-demo"
                  fullWidth
                  options={generateResultados()}
                  value={resultado}
                  renderInput={(params: any) => (
                    <>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Resultado *"
                        required
                        fullWidth
                      />
                    </>
                  )}
                  renderOption={(option) => <CustomOption option={option} />}
                  getOptionSelected={(option: any) => option?.nome || ""}
                  getOptionLabel={(option: any) => option?.nome || ""}
                  // @ts-ignore
                  onChange={(
                    event: any,
                    newValue: {
                      id: string | null;
                      nome: string | null;
                      codigo: string | null;
                    } | null
                  ) => {
                    setResultado(newValue);
                  }}
                />
              </Styles.Column>
            </Styles.RowGap>
            {/* Acompanhamento */}

            {/* Agendou visita */}
            {resultado?.codigo === "8" || resultado?.codigo === "10" ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />

                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Data <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>
                      Hora <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa?.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                {!(fromCalendario && inserirNoOutlookOverride) && (
                  <Styles.RowGap>
                    <Styles.RowGap>
                      <Styles.FormControlLabel
                        control={
                          <Styles.Checkbox
                            defaultChecked
                            checked={inserirTarefaNoOutlook}
                            onChange={() =>
                              setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                            }
                          />
                        }
                        label="Criar compromisso na agenda"
                      />
                    </Styles.RowGap>
                  </Styles.RowGap>
                )}
              </>
            ) : null}
            {resultado?.codigo === "2" ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />

                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Data <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>
                      Hora <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                {isSul ? (
                  <>
                    {" "}
                    <Styles.RowGap>
                      <Styles.Column>
                        <Styles.LabelText>
                          Local <p>{" *"}</p>
                        </Styles.LabelText>
                        <Styles.Autocomplete
                          id="combo-box-demo"
                          fullWidth
                          options={
                            dataEmpreendimento2
                              ? dataEmpreendimento2?.data?.map((item: any) => ({
                                  id: item?.idEmpreendimento,
                                  nome: item?.nome,
                                }))
                              : []
                          }
                          value={produtoSul}
                          renderInput={(params: any) => (
                            <>
                              <Styles.TextField
                                size="small"
                                InputLabelProps={{ shrink: false }}
                                variant="outlined"
                                {...params}
                                label="Tipo da tarefa"
                                required
                                fullWidth
                              />
                            </>
                          )}
                          getOptionSelected={(option: any) => option?.nome}
                          getOptionLabel={(option: any) => option?.nome || ""}
                          // @ts-ignore
                          onChange={(event: any, newValue: any) => {
                            setProdutoSul(newValue);
                          }}
                        />
                      </Styles.Column>
                    </Styles.RowGap>
                  </>
                ) : (
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Produto <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        fullWidth
                        options={
                          dataEmpreendimento2
                            ? dataEmpreendimento2?.data?.map((item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={empreendimentoNovaTarefa}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Resultado *"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(
                          event: any,
                          newValue: {
                            id: string | null;
                            nome: string | null;
                          } | null
                        ) => {
                          setEmpreendimentoNovaTarefa(newValue);
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                )}
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa?.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                {!(fromCalendario && inserirNoOutlookOverride) && (
                  <Styles.RowGap>
                    <Styles.RowGap>
                      <Styles.FormControlLabel
                        control={
                          <Styles.Checkbox
                            defaultChecked
                            checked={inserirTarefaNoOutlook}
                            onChange={() =>
                              setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                            }
                          />
                        }
                        label="Criar compromisso na agenda"
                      />
                    </Styles.RowGap>
                  </Styles.RowGap>
                )}
              </>
            ) : null}
            {resultado?.codigo === "1" ||
            resultado?.codigo === "3" ||
            (resultado?.codigo === "4" && isSul) ||
            resultado?.codigo === "6" ||
            resultado?.codigo === "7" ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
              </>
            ) : null}

            {resultado?.codigo === "9" && !isSul ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload(
                        val?.map((item: any) => ({
                          nome: item.nome,
                          anexoBase64: formatarBase64(item.base64),
                        }))
                      )
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Data <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>
                      Hora <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                {isSul ? (
                  <>
                    {" "}
                    <Styles.RowGap>
                      <Styles.Column>
                        <Styles.LabelText>
                          Produto <p>{" *"}</p>
                        </Styles.LabelText>
                        <Styles.Autocomplete
                          id="combo-box-demo"
                          defaultValue={{
                            nome: "Selecione um tipo da tarefa",
                            id: "1",
                          }}
                          fullWidth
                          options={
                            dataEmpreendimento2
                              ? dataEmpreendimento2?.data?.map((item: any) => ({
                                  id: item?.idEmpreendimento,
                                  nome: item?.nome,
                                }))
                              : []
                          }
                          value={produtoSul}
                          renderInput={(params: any) => (
                            <>
                              <Styles.TextField
                                size="small"
                                InputLabelProps={{ shrink: false }}
                                variant="outlined"
                                {...params}
                                label="Tipo da tarefa"
                                required
                                fullWidth
                              />
                            </>
                          )}
                          getOptionSelected={(option: any) => option?.nome}
                          getOptionLabel={(option: any) => option?.nome || ""}
                          // @ts-ignore
                          onChange={(event: any, newValue: any) => {
                            setProdutoSul(newValue);
                          }}
                        />
                      </Styles.Column>
                    </Styles.RowGap>
                  </>
                ) : (
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>
                        Produto <p>{" *"}</p>
                      </Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        fullWidth
                        disabled
                        options={
                          dataEmpreendimento2
                            ? dataEmpreendimento2?.data?.map((item: any) => ({
                                id: item?.idEmpreendimento,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={empreendimento}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Resultado *"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(
                          event: any,
                          newValue: {
                            id: string | null;
                            nome: string | null;
                          } | null
                        ) => {
                          setEmpreendimento(newValue);
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                )}

                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>

                {!(fromCalendario && inserirNoOutlookOverride) && (
                  <Styles.RowGap>
                    <Styles.RowGap>
                      <Styles.FormControlLabel
                        control={
                          <Styles.Checkbox
                            defaultChecked
                            checked={inserirTarefaNoOutlook}
                            onChange={() =>
                              setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                            }
                          />
                        }
                        label="Criar compromisso na agenda"
                      />
                    </Styles.RowGap>
                  </Styles.RowGap>
                )}
              </>
            ) : null}

            {/* SUL */}
            {/* Atendimento realizado */}
            {isSul && resultado?.codigo === "4" ? (
              <>
                <Divider text="Sobre o atendimento" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      {tipoVisitaRetorno === 1
                        ? "Motivo da visita"
                        : "Motivo do retorno"}{" "}
                      <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataMotivosAtendimento
                          ? dataMotivosAtendimento?.data?.motivos?.map(
                              (item: any) => ({
                                id: item?.codigo,
                                nome: item?.nome,
                              })
                            )
                          : []
                      }
                      value={motivoAtendimento}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Resultado *"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(
                        event: any,
                        newValue: {
                          id: string | null;
                          nome: string | null;
                        } | null
                      ) => {
                        setMotivoAtendimento(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Especialista que acompanhou<p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo da tarefa",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataCorretorParceiro
                          ? dataCorretorParceiro?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={corretorParceiro}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setCorretorParceiro(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={16} />
                {/* <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Produto de interesse</Styles.LabelText>
                    <Styles.Autocomplete
                      disabled={false}
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um empreendimento",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataEmpreendimento2
                          ? dataEmpreendimento2?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={empreendimento}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setEmpreendimento(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap> */}
                <Styles.SpaceY space={16} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Objetivo de compra<p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo da tarefa",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataObjetivosCompra
                          ? dataObjetivosCompra?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={objetivoCompra}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setObjetivoCompra(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Divider text="Sobre o cliente" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Profissão<p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo da tarefa",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataProfissoes
                          ? dataProfissoes?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={profissao}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setProfissao(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Bairro residêncial<p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      label="Bairro"
                      fullWidth
                      onChange={(e: any) => setBairro(e.target.value)}
                      value={bairro}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Idade<p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      label="Idade"
                      fullWidth
                      onChange={(e: any) => {
                        // Remove caracteres não numéricos
                        const value = e.target.value.replace(/\D/g, "");
                        // Garante que o valor tenha no máximo 3 dígitos
                        const idadeValue = value.slice(0, 3);
                        // Garante que o valor esteja no intervalo [0, 130]
                        const idadeNumerico = parseInt(idadeValue, 10);
                        const idadeFinal = isNaN(idadeNumerico)
                          ? ""
                          : Math.min(idadeNumerico, 130).toString();
                        // Atualiza o estado com o novo valor
                        setIdade(idadeFinal);
                      }}
                      value={idade}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Temperatura</Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataTemperaturasLead
                          ? dataTemperaturasLead?.data?.map((item: any) => ({
                              id: item?.idSistemaOrigem ?? item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={temperatura}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setTemperatura(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                {/* <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>Observação</Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap> */}
              </>
            ) : null}
            {resultado?.codigo === "9" && isSul ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Data</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>
                      Hora <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoNovaTarefa}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoNovaTarefa(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                {isSul ? (
                  <>
                    {" "}
                    <Styles.RowGap>
                      <Styles.Column>
                        <Styles.LabelText>
                          Local <p>{" *"}</p>
                        </Styles.LabelText>
                        <Styles.Autocomplete
                          id="combo-box-demo"
                          defaultValue={{
                            nome: "Selecione um tipo da tarefa",
                            id: "1",
                          }}
                          fullWidth
                          options={
                            dataEmpreendimento2
                              ? dataEmpreendimento2?.data?.map((item: any) => ({
                                  id: item?.idEmpreendimento,
                                  nome: item?.nome,
                                }))
                              : []
                          }
                          value={empreendimentoNovaTarefa}
                          renderInput={(params: any) => (
                            <>
                              <Styles.TextField
                                size="small"
                                InputLabelProps={{ shrink: false }}
                                variant="outlined"
                                {...params}
                                label="Tipo da tarefa"
                                required
                                fullWidth
                              />
                            </>
                          )}
                          getOptionSelected={(option: any) => option?.nome}
                          getOptionLabel={(option: any) => option?.nome || ""}
                          // @ts-ignore
                          onChange={(event: any, newValue: any) => {
                            setEmpreendimentoNovaTarefa(newValue);
                          }}
                        />
                      </Styles.Column>
                    </Styles.RowGap>
                  </>
                ) : (
                  <Styles.RowGap>
                    <Styles.Column>
                      <Styles.LabelText>Produto</Styles.LabelText>
                      <Styles.Autocomplete
                        id="combo-box-demo"
                        fullWidth
                        disabled
                        options={
                          dataEmpreendimento2
                            ? dataEmpreendimento2?.data?.map((item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              }))
                            : []
                        }
                        value={empreendimento}
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Resultado *"
                              required
                              fullWidth
                            />
                          </>
                        )}
                        getOptionSelected={(option: any) => option?.nome}
                        getOptionLabel={(option: any) => option?.nome || ""}
                        // @ts-ignore
                        onChange={(
                          event: any,
                          newValue: {
                            id: string | null;
                            nome: string | null;
                          } | null
                        ) => {
                          setEmpreendimento(newValue);
                        }}
                      />
                    </Styles.Column>
                  </Styles.RowGap>
                )}
                <Styles.SpaceY space={8} />
                {/* <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Local *</Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      label="Titulo"
                      fullWidth
                      onChange={(e: any) => setLocalSul(e.target.value)}
                      value={localSul}
                    />
                  </Styles.Column>
                </Styles.RowGap> */}
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                {!(fromCalendario && inserirNoOutlookOverride) && (
                  <Styles.RowGap>
                    <Styles.RowGap>
                      <Styles.FormControlLabel
                        control={
                          <Styles.Checkbox
                            defaultChecked
                            checked={inserirTarefaNoOutlook}
                            onChange={() =>
                              setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                            }
                          />
                        }
                        label="Criar compromisso na agenda"
                      />
                    </Styles.RowGap>
                  </Styles.RowGap>
                )}
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={solicitarPresencaEspecialista}
                        onChange={() =>
                          setSolicitarPresencaEspecialista(
                            !solicitarPresencaEspecialista
                          )
                        }
                      />
                    }
                    label="Solicitar presença de um especialista"
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {resultado?.codigo === "4" && !isSul ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {/* Desqualificar */}
            {resultado?.codigo === "5" ? (
              <>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Motivo <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo de atendimento",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataMotivosDesqualificacao
                          ? dataMotivosDesqualificacao?.data?.map(
                              (item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              })
                            )
                          : []
                      }
                      value={motivoDesqualificacao}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Resultado *"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(
                        event: any,
                        newValue: {
                          id: string | null;
                          nome: string | null;
                        } | null
                      ) => {
                        setMotivoDesqualificacao(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
              </>
            ) : null}
          </>
        ) : null}
      </Styles.ScrollContentV2>
      <Styles.FooterDialog>
        <Styles.Button
          style={{ width: "100%" }}
          variant="outlined"
          onClick={() => {
            props.closeModal();
          }}
        >
          Fechar
        </Styles.Button>
        {isCorretor ? (
          <Styles.SaveButton
            onClick={() => handleSubmit()}
            style={{
              width: "100%",
              background: "#4a76fb",
              boxShadow: "none",
              color: "#fff !important",
            }}
            className={
              !canSaveSul ||
              isLoading ||
              empreendimentoNaoInformado ||
              dataAssinaturaNoPassado
                ? "disabled"
                : ""
            }
            disabled={
              !canSaveSul ||
              isLoading ||
              empreendimentoNaoInformado ||
              dataAssinaturaNoPassado
            }
          >
            {isLoading ? <BeatLoader color="#fff" size={10} /> : "Salvar"}
          </Styles.SaveButton>
        ) : null}
      </Styles.FooterDialog>
    </Styles.DialogHeader>
  );
};

export default NewTaskV2;
